// import React from "react";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { IoPerson } from "react-icons/io5";
// import "./userhome.css"
// const UserHome = () => {
//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Profile</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home </Link></li>
//                             <li>My Profile</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>


//             <div >
//                 <div className="profilecon">
//                     <Usernav />
//                     <div class="col-xl-8 col-lg-12 profile">
//                         <div className="d-flex"><div className="person"><IoPerson /></div> <span style={{ fontSize: "20px" }}>My Profile</span></div>
//                         <div className=" usercontiner">
//                             <div className="name"></div>
//                             <div className="order"> All Orders</div>

//                             <div className="ship">Awaiting Shipment</div>
//                             <div className="dilivery">Awaiting Delivery</div>
//                         </div>
//                         <div className="user">
//                             <div><h6>First Name</h6><p>user.firstname</p></div>
//                             <div><h6>Last Name</h6><p>user.lastnamea</p></div>
//                             <div><h6>Email</h6><p>user.email</p></div>
//                             <div><h6>Phone</h6><p>user.phone</p></div>
//                             <div><h6>Birth date</h6><p>user.dob</p></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };
// export default UserHome;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { IoPerson } from "react-icons/io5";
// import "./userhome.css";

// const UserHome = () => {
//   const [user, setUser] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     mob_number: "",
//     dob: "",
//     password: "",
//   });
//   const [isEditing, setIsEditing] = useState(false);
//   const [isNewUser, setIsNewUser] = useState(false);

//   const userId = "USER_ID"; // Replace with dynamic user ID from context/auth

//   // Fetch user data
//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const response = await axios.get(`/api/profile/${userId}`);
//         if (response.data) {
//           setUser(response.data);
//         } else {
//           setIsNewUser(true);
//         }
//       } catch (error) {
//         console.error("Error fetching user", error);
//         setIsNewUser(true); // Assume new user if fetch fails
//       }
//     };
//     fetchUser();
//   }, [userId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUser({ ...user, [name]: value });
//   };

//   const saveProfile = async () => {
//     try {
//       if (isNewUser) {
//         // POST request for new user
//         const response = await axios.post('/api/profile', user);
//         alert(response.data.message);
//       } else {
//         // PUT request for existing user
//         const response = await axios.put(`/api/profile/${userId}`, user);
//         alert(response.data.message);
//       }
//       setIsEditing(false);
//       setIsNewUser(false); // Switch to existing user mode after saving
//     } catch (error) {
//       console.error("Error saving profile", error);
//       alert("Failed to save profile");
//     }
//   };

//   return (
//     <>
//       <div className="breadcrumb-wrap bg-f br-2 mt-5">
//         <div className="container">
//           <div className="breadcrumb-title">
//             <h2>My Profile</h2>
//             <ul className="breadcrumb-menu list-style">
//               <li><Link to="#">Home </Link></li>
//               <li>My Profile</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//       <div className="profilecon">
//         <Usernav />
//         <div className="col-xl-8 col-lg-12 profile">
//           <div className="d-flex">
//             <div className="person"><IoPerson /></div>
//             <span style={{ fontSize: "20px" }}>My Profile</span>
//           </div>
//           <div className="user">
//             {(isEditing || isNewUser) ? (
//               <>
//                 <div>
//                   <h6>First Name</h6>
//                   <input
//                     type="text"
//                     name="firstname"
//                     value={user.firstname}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Last Name</h6>
//                   <input
//                     type="text"
//                     name="lastname"
//                     value={user.lastname}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Email</h6>
//                   <input
//                     type="email"
//                     name="email"
//                     value={user.email}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Phone</h6>
//                   <input
//                     type="text"
//                     name="mob_number"
//                     value={user.mob_number}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Birth Date</h6>
//                   <input
//                     type="date"
//                     name="dob"
//                     value={user.dob}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Password</h6>
//                   <input
//                     type="password"
//                     name="password"
//                     value={user.password}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <button onClick={saveProfile} className="btn btn-primary">
//                   {isNewUser ? "Add" : "Save"}
//                 </button>
//               </>
//             ) : (
//               <>
//                 <div><h6>First Name</h6><p>{user.firstname}</p></div>
//                 <div><h6>Last Name</h6><p>{user.lastname}</p></div>
//                 <div><h6>Email</h6><p>{user.email}</p></div>
//                 <div><h6>Phone</h6><p>{user.mob_number}</p></div>
//                 <div><h6>Birth Date</h6><p>{user.dob}</p></div>
//                 <div><h6>Password</h6><p>******</p></div>
//                 <button
//                   onClick={() => setIsEditing(true)}
//                   className="btn btn-secondary"
//                 >
//                   Edit
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UserHome;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Usernav from "../usernav/usernav";
import { MdEdit } from "react-icons/md";
import { IoPerson } from "react-icons/io5";
import "./userhome.css";

const UserHome = () => {
  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mob_number: localStorage.getItem("phoneNumber"),
    dob: "",
    password: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);

  const phoneNumber = localStorage.getItem("phoneNumber");


  // Fetch user data if phoneNumber exists
  useEffect(() => {
    const fetchUser = async () => {
      if (!phoneNumber) {
        setIsNewUser(true);
        return;
      }
      try {
        const response = await axios.get(
          `/api/profile?phone=${phoneNumber}`
        );
        if (response.data) {
          setUser(response.data);
          setIsNewUser(false);
        } else {
          setIsNewUser(true);
        }
      } catch (error) {
        console.error("Error fetching user", error);
        setIsNewUser(true); // Assume new user if fetch fails
      }
    };
    fetchUser();
  }, [phoneNumber]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const saveProfile = async () => {
    try {
      if (isNewUser) {
        // POST request for new user
        const response = await axios.post("/api/profile", user);
        alert(response.data.message);
        localStorage.setItem("phoneNumber", user.mob_number); // Save phone number to localStorage
      } else {
        // PUT request for existing user
        const response = await axios.put(
          `/api/profile/${user.mob_number}`,
          user
        );
        alert(response.data.message);
      }
      setIsEditing(false);
      setIsNewUser(false); // Switch to existing user mode after saving
    } catch (error) {
      console.error("Error saving profile", error);
      alert("Failed to save profile");
    }
  };

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container "  style={{marginBottom:'-90px'}}>
          <div className="breadcrumb-title">
            <h2>User Dashboard</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">Home </Link></li>
              <li>My Profile</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="containerorder">
        <div className="row ">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
  {/* Sidebar */}
  <div
    style={{
      width: '100%',
      maxWidth: '320px',
      padding: '20px',
      borderRadius: '12px',
    
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      boxSizing: 'border-box',
    }}
  >
    <Usernav />
  </div>

  {/* Profile Content */}
 <div
  style={{
    flex: 1,
    padding: '24px',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
    minWidth: '300px',
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
    <div
      style={{
        backgroundColor: '#f0f4f8',
        padding: '10px',
        borderRadius: '50%',
        marginRight: '12px',
      }}
    >
      <IoPerson size={30} color="#4b5563" />
    </div>
    <span style={{ fontSize: "22px", fontWeight: 600, color: '#1f2937' }}>
      My Profile
    </span>
  </div>

  <div className="user">
    {(isEditing || isNewUser) ? (
      <>
        {[
          { label: "First Name", name: "firstname", type: "text" },
          { label: "Last Name", name: "lastname", type: "text" },
          { label: "Email", name: "email", type: "email" },
          { label: "Phone", name: "mob_number", type: "text" },
          { label: "Password", name: "password", type: "password" },
        ].map((field) => (
          <div
            key={field.name}
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '18px',
            }}
          >
            <label
              htmlFor={field.name}
              style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#374151',
                marginBottom: '6px',
              }}
            >
              {field.label}
            </label>
            <input
              id={field.name}
              className="profileinput"
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '6px',
                border: '1px solid #cbd5e1',
                fontSize: '14px',
              }}
              type={field.type}
              name={field.name}
              value={user[field.name]}
              onChange={handleChange}
            />
          </div>
        ))}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
          <button
            onClick={saveProfile}
            style={{
              backgroundColor: '#22c55e',
              color: 'white',
              padding: '10px 24px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#16a34a'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#22c55e'}
          >
            {isNewUser ? "Add" : "Save"}
          </button>
        </div>
      </>
    ) : (
      <>
        {[
          { label: "First Name", value: user.firstname },
          { label: "Last Name", value: user.lastname },
          { label: "Email", value: user.email },
          { label: "Phone", value: user.mob_number },
          { label: "Password", value: "******" },
        ].map((field, i) => (
          <div
            key={i}
            style={{
              marginBottom: '16px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <label style={{ fontSize: '14px', fontWeight: 500, color: '#4b5563', marginBottom: '4px' }}>
              {field.label}
            </label>
            <p style={{ margin: 0, color: "#1f2937", fontWeight: 500 }}>{field.value}</p>
          </div>
        ))}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <button
            onClick={() => setIsEditing(true)}
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #3b82f6',
              color: '#3b82f6',
              padding: '8px 16px',
              borderRadius: '6px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#3b82f6';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#3b82f6';
            }}
          >
            <MdEdit style={{ marginRight: '6px' }} />
            Edit Profile
          </button>
        </div>
      </>
    )}
  </div>
</div>


</div>

        </div>
      </div>
    </>
  );
};

export default UserHome;
